<template>
    <div id="footer">
        <div class="footer-section">
            <div class="wow fadeInLeft nav_wrapper row" data-wow-delay="0.8s">
                <span  class="wow fadeInLeft logo_wrapper col-4" data-wow-delay="0.8s"><img class="logo" src="./img/EachYun.png"></span>
                <div class="nav col-4">
                    <ul class="nav-list">
                      <li :class="{ ecactive: navActiveItem.home }"><router-link to="/" class="smoothScroll"><span>{{$t("header.home")}}</span></router-link></li>
                      <li :class="{ ecactive: navActiveItem.products }"><router-link to="/products" class="smoothScroll"><span>{{$t("header.products")}}</span></router-link></li>
                    </ul>
                    <ul class="nav-list">
                      <li :class="{ ecactive: navActiveItem.solutions }"><router-link to="/solutions" class="smoothScroll"><span>{{$t("header.solutions")}}</span></router-link></li>
                      <li :class="{ ecactive: navActiveItem.partner }"><router-link to="/partner" class="smoothScroll"><span>{{$t("header.partner")}}</span></router-link></li>
                    </ul>
                    <ul class="nav-list">
                      <li :class="{ ecactive: navActiveItem.about }"><router-link to="/about" class="smoothScroll"><span>{{$t("header.about")}}</span></router-link></li>
                      <li :class="{ ecactive: navActiveItem.contact }"><router-link to="/contact" class="smoothScroll"><span>{{$t("header.contact")}}</span></router-link></li>
                    </ul>
                </div>
                <div class="qr_code_wrapper col-4">
                    <img class="ec-img-erweima" alt="扫描二维码,关注亿企云!" src="./img/qrcode-eachcloud.jpg" />
                    <span class="qr_code_title">{{$t("footer.erweima_text")}}</span>
                    <!-- <div class="arrows_wrapper">
                        <img class="arrows" src="./img/arrows.png" />
                    </div> -->
                </div>
            </div>
            <div class="wow fadeInLeft" data-wow-delay="0.8s">
                <p class="promise">{{$t("footer.promise_text")}}</p>
            </div>
        </div>
        <div class="last-section">
            <p  class="wow fadeInLeft bottom_logo" data-wow-delay="0.8s">
                <img class="logo" src="./img/EachYun.png">
            </p>
            <p class="wow fadeInLeft footer-section2" data-wow-delay="0.5s">
                <span>{{$t("footer.copyright")}}</span>
                <!-- <span class="aq">{{$t("footer.AQ")}}</span> -->
                <a href="http://beian.miit.gov.cn" target="_blank" class="aq">{{$t("footer.AQ")}}</a>
            </p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
      navActiveItem:{type:Object,default: ()=> {return{}}}
    }
  }
</script>
<style>
    #footer{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        /*padding:0 0 0px 0;*/
        background:rgba(101,93,87,0.4);
        color: #365675;
        font-size: 15px;
    }
    .footer-section2 {
        padding-top: 10px;
    }
     #footer .footer-section2 {
        font-size: 16px;
    }
    #footer .bottom_logo {
        display: none;
    }
    #footer img.logo {
        display: block;
        width: 80px;
        height: auto;
    }
    #footer .aq {
        margin-left: 5px;
    }
    #footer .logo_wrapper {
        display: inline-block;
        width: 110px;
        height: 110px;
        margin-right: 50px;
        /*border-right: solid 1px gray;*/
    }
    #footer .logo_wrapper img.logo {
        width: 110px ;
        height: 110px;
    }
    #footer .footer-section {
        width: 100%;
        background:rgba(101,93,87,0.1);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    #footer .nav_wrapper {
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #footer .nav-list {
        display: inline-block;
        text-decoration: none;
        list-style: none;
    }
    #footer .nav{
        height: 110px;
        padding-right: 50px;
        padding-left: 30px;
        border-left: solid 1px #9C9292;
        border-right: solid 1px #9C9292;
    }
    #footer .nav-list li {
        margin-top: 20px;
    }
    #footer .nav-list li a {
        color: #365675;
    }
    #footer .nav-list li a:hover {
        color: #AA6D6A;
        text-decoration: none;
    }
    #footer .qr_code_wrapper {
        display: inline-block;
        text-align: center;
        width: 110px;
        height: 120px;
        background-color: white;
        position: relative;
        margin: 20px 0px 20px 70px;
    }
    #footer .ec-img-erweima {
        width: 80px;
        height: 80px;
        margin: 10px 10px 0 10px;
    }
    #footer .qr_code_title {
        color: #736D6D;
        font-size: 12px;
        margin-top: 8px;
        display: inline-block;
    }
    #footer .arrows_wrapper {
        width: 100px;
        position: absolute;
        top: 0;
        left: 180px;
        transform: rotate(200deg);
        -ms-transform: rotate(200deg);
        -webkit-transform: rotate(200deg);
    }
    .promise {
        font-size: 15px;
    }
@media only screen and (max-width: 768px) {
    #footer p{
        font-size: 13px;
    }
     span {
        display: block;
    }
    #footer .footer-section {
        display: none;
    }
    #footer .bottom_logo {
        display: block;
    }
    #footer .footer-section2 {
        padding-top: 0;
    }
    .last-section {
       /* height: 300px;*/
        /*margin-bottom: 20px;*/
    }
    .last-section .bottom_logo {
        text-align: center;
        display: flex !important;
        justify-content: center;
        margin-bottom: 0px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue